export default __webpack_public_path__ + "static/media/peoples.24ee2a68.svg";